class RarityFilter extends HTMLElement {
  connectedCallback() {
    this.chips = Array.from(this.querySelectorAll('.filter-chip'));
    this.grid = document.querySelector('[data-pebbl-product-grid]');
    this.emptyMessage = document.querySelector('[data-pebbl-grid-empty]');
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const chip = event.target.closest('.filter-chip');
    if (!chip) return;

    this.chips.forEach((c) => c.classList.toggle('active', c === chip));
    this.applyFilter(chip.dataset.filter || '');
  }

  applyFilter(rarity) {
    if (!this.grid) return;
    const cards = this.grid.querySelectorAll('.pcard');
    let visibleCount = 0;
    cards.forEach((card) => {
      const matches = rarity === '' || card.dataset.rarity === rarity;
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (this.emptyMessage) {
      this.emptyMessage.hidden = visibleCount !== 0;
    }
  }
}

customElements.define('rarity-filter', RarityFilter);
